import { useState, useEffect } from 'react';
import client from '../../sanityClient'; 
import imageUrlBuilder from '@sanity/image-url';
import Section from '../Section';
import TeamSection from '../Section/TeamSection';
import GallerySection from '../Section/GallerySection';
import { pageTitle } from '../../helpers/PageTitle';
import AboutSectionStyle3 from '../Section/AboutSection/AboutSectionStyle3';
import Cta from '../Cta';
import { useLocation } from 'react-router-dom';

const builder = imageUrlBuilder(client);
const urlFor = (source) => builder.image(source);



const galleryData = {
  harriman: [
    { imgUrl: '/images/about/portfolio_4_lg.jpeg' },
    { imgUrl: '/images/about/portfolio_2_lg.jpeg' },
    { imgUrl: '/images/about/portfolio_3_lg.jpeg' },
    { imgUrl: '/images/about/portfolio_1_lg.jpeg' },
    { imgUrl: '/images/about/portfolio_5_lg.jpeg' },
  ],
  newburgh: [
    { imgUrl: '/images/about/newburgh_1.jpeg' },
    { imgUrl: '/images/about/newburgh_3.jpeg' },
    { imgUrl: '/images/about/newburgh_2.jpeg' },
    { imgUrl: '/images/about/newburgh_4.jpeg' },
    { imgUrl: '/images/about/newburgh_5.jpeg' },
  ],
};


export default function About() {

  const [teamData, setTeamData] = useState([])
  const location = useLocation();

  useEffect(() => {
    console.log("useEffect triggered, hash:", location.hash);

    client.fetch(`*[_type == "teamMember"] | order(order asc) {
      _id,
      name,
      title,
      credentials,
      photo,
      background,
      interests
    }`)
      .then((data) => {
        console.log("Sanity team data:", data); 

        const mappedData = data.map(member => ({
          name: member.name,
          designation: member.title,
          credentials: member.credentials,
          imgUrl: member.photo ? urlFor(member.photo).width(400).url() : '',
          background: member.background,
          interests: member.interests,
        }))
        setTeamData(mappedData)
      })
      .catch(console.error);

    if (location.hash) {
      setTimeout(() => {
        const section = document.querySelector(location.hash);
        if (section) {
          section.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    }
}, [location]);

  
  
  
  
  pageTitle('About');
  return (
    <>
      
      <Section bottomMd={95} bottomLg={70} bottomXl={50}>
        <AboutSectionStyle3
          titleUp="MISSION STATEMENT"
          title="Helping children develop to their fullest potential"
          subTitle="Our mission is to treat young children with developmental delays and emerging social concerns in the earliest months and years of life, in order to give every child we serve the chance to develop to his or her fullest potential and gain the greatest success and enjoyment of learning and life."
          imgUrl="/images/about/girls-having-fun.jpg"
        />
      </Section>
      
      <Section topMd={95} topLg={70} topXl={50}>
        <TeamSection
          sectionTitle="Wonderful Team"
          sectionTitleUp="MEET OUR"
          data={teamData}
        />
      </Section>
      <Section topMd={95} topLg={70} topXl={50} id="cta-section">
        <Cta
          title="Want to Join Our Wonderful Team?"
          subTitle="Email us your resume at info@starbrightaba.com"
          bgUrl="/images/about/cta-bg.jpg"
          btnUrl="mailto:info@starbrightaba.com"
          btnText="Email Us"
          featuredImg="/images/about/teamfun.jpg"
          imgCaption="Team night out!"
        />
      </Section>
      <Section topMd={170} topLg={120} topXl={80} bottomMd={95} bottomLg={70} bottomXl={50}>
        <GallerySection
          sectionTitle="Our Therapy and <br />Learning Spaces"
          sectionTitleUp="HAVE A LOOK AT"
          data={galleryData}
        />
      </Section>
      
    </>
  );
}
